import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VesselRedundancyGroup } from '../dto/vessel-redundancy-group';

@Injectable({
  providedIn: 'root'
})
export class VesselRedundancyGroupService {

  private apiUrl = environment.apiRoot + '/vesselredundancygroup';

  constructor(private http: HttpClient) { }

  getAllRedundancyGroupOfVessel(vesselId: number): Observable<VesselRedundancyGroup[]> {
    return this.http.get<VesselRedundancyGroup[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  createRedundancyGroup(vesselId: number): Observable<VesselRedundancyGroup> {
    let model = { "id": 0, "vessel_id": vesselId, "name": "new redundancy group" };
    return this.http.post<VesselRedundancyGroup>(this.apiUrl + '/new', model);
  }

  updateRedundancyGroup(model: VesselRedundancyGroup): Observable<VesselRedundancyGroup> {
    return this.http.put<VesselRedundancyGroup>(this.apiUrl + '/update', model);
  }

  deleteRedundancyGroup(redundancyGroupId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?redundancyGroupId=' + redundancyGroupId);
  }

}
